import { ITransferExamsDatasource } from './../datasources/transfer_exams_datasource';

angular.module('capability-ng-transfer').run((ngTransferExamDatasource: ITransferExamsDatasource, log: any) => {
  ngTransferExamDatasource.$prePut = (v) => {
    if (!ngTransferExamDatasource.model.hasFirstExamBeenSelected) {
      log.user.success({
        content: `Congratulations, you've added your first credit!`,
        timeout: 10000,
        dismissOnTimeout: true,
        dismissButton: true
      });
    }
    return v;
  };

  ngTransferExamDatasource.$preWrite = (v) => {
    ngTransferExamDatasource.model.hasFirstExamBeenSelected = true;
    return v;
  };

  ngTransferExamDatasource.$postWrite = (v) => {
    if (!(ngTransferExamDatasource.size() > 0)) {
      ngTransferExamDatasource.model.hasFirstExamBeenSelected = false;
    }
    return v;
  };

  ngTransferExamDatasource.$postPut = (v) => {
    ngTransferExamDatasource.model.hasFirstExamBeenSelected = true;
    return v;
  };

  ngTransferExamDatasource.$postClear = () => {
    ngTransferExamDatasource.model.hasFirstExamBeenSelected = false;
    return ngTransferExamDatasource;
  };
});



// WEBPACK FOOTER //
// ./app/lib/transfer/notifications/first_exam_added_notification.ts